import { memo } from 'react';
import styles from './RequestAppointment.module.scss';

export const RequestAppointment = memo(({ children }) => {
  return (
    <div className={styles.requestContainer}>
      <h2 className={styles.requestHeading}>Let's Get Started</h2>
      <h3 className={styles.requestSubHeading}>
        You bring energy, passion, and a drive to build your business - we'll take care of the rest.
      </h3>
      {children}
    </div>
  );
});
